import React, { Component } from "react";
import axios from "axios";
export default class Footer extends Component {
  constructor() {
    super();
    this.state = {
      homeData: null
    };
  }
  componentDidMount() {
    const ROOT_URL = "https://info.ffbwi.com";

    axios
      .get(ROOT_URL + "/wp-json/wp/v2/landingpages?slug=rewards-checking")
      .then(res => {
        this.setState({
          homeData: res.data[0].acf
        });
      });
  }

  render() {
    const { homeData } = this.state;
    if (homeData) {
      return (
        <footer className="footer">
          <div className="content has-text-centered">
            <p>©2019 First Federal Bank Member FDIC, Equal Housing Lender</p>
            <a href="https://www.firstfederalwisconsin.com/privacy-and-security/">
              Privacy Policy
            </a>
            {homeData.disclosures && (
              <div className="disclosures">
                <strong>Important Information</strong>
                <br />
                {homeData.disclosures}
              </div>
            )}
          </div>
        </footer>
      );
    } else return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js